export default function assert(condition: boolean, errorMessage = ""): asserts condition {

    if (condition !== true) {

        throw new Error(errorMessage);

    }

}
